import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/CustomersProject/Columns';
import { STORAGE_KEYS } from '../../utils/localStorageKeys';
import { SisDataGrid, SortingMode } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export const CustomersProjectsDataGrid = ({ data, handleEdit }: IDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'CustomersProjects.List';
  const history = useHistory();

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Customers projects', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => history.push(`/customers-projects/new/`),
        },
      },
    );
  };
  return (
    <SisDataGrid
      data={data}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={Columns(handleEdit, translate)}
      onCellDblClick={(e) => handleEdit && handleEdit(e)}
      columnChooser={false}
      allowColumnResizing={false}
      allowColumnReordering={false}
      onToolbarPreparing={onToolbarPreparing}
      pageSizeChangeVisible
      enableContextMenu
      newTabLink="/customers-projects/edit/"
      sortingMode={SortingMode.MULTIPLE}
      enableGrouping
      stateStoringKey={STORAGE_KEYS.CUSTOMER_PROJECT_DATAGRID}
    />
  );
};
